import styles from './TaskPreparingModal.module.css';

export default function TaskPreparingModal({isDone,text,onClick}){
return(
    <div className={styles['loading-background']}>
        <div className={styles['loading-modal']}>
            <div className={`${styles['loading-icon']} ${isDone && styles['loading-done']}`}>
              <svg class={styles['loading-progress']}viewBox="25 25 50 50" >
                <circle class={styles['loading-progress-path']} cx="50" cy="50" r="23" fill="none" stroke="black" stroke-width="4" />
              </svg>
            {isDone &&
            <svg className={styles["loading-checkmark"]} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className={styles["loading-checkmark-circle"]} cx="26" cy="26" r="25" fill="none"/>
              <path className={styles["loading-checkmark-check"]} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
            }
            </div>
            <span className={`${styles['loading-text']} ${isDone && styles['loading-done']}`}>{text}
            </span>
            { isDone && 
            <div className={`${styles['loading-btn']} ${styles['loading-done']}`} onClick={onClick}>Task List &gt;</div>}
        </div>
    </div>
)}